import type { SVGProps } from "react";

const DeleteIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="28"
      height="28"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill="#FF6961" fillOpacity="0.1" />
      <path
        d="M8.25 11.0013H23.25M21.5833 11.0013V22.668C21.5833 23.5013 20.75 24.3346 19.9167 24.3346H11.5833C10.75 24.3346 9.91667 23.5013 9.91667 22.668V11.0013M12.4167 11.0013V9.33464C12.4167 8.5013 13.25 7.66797 14.0833 7.66797H17.4167C18.25 7.66797 19.0833 8.5013 19.0833 9.33464V11.0013M14.0833 15.168V20.168M17.4167 15.168V20.168"
        stroke="#FF6961"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeleteIcon;
